<script setup lang="ts">
/**
 * Compact, flat model card for marketing surfaces (landing teaser).
 * Hairline border, rounded-lg, no shadow — DESIGN.md card treatment.
 */
import { formatUsd } from '../../lib/format';

const props = defineProps<{
  name: string;
  id: string;
  per1mUsd: number | null;
  contextWindow: number | null;
  tools?: boolean;
  reasoning?: boolean;
}>();

function fmtContext(n: number | null): string {
  if (n == null) return '—';
  return n >= 1000 ? `${Math.round(n / 1000)}K context` : `${n} context`;
}
const price = props.per1mUsd != null ? formatUsd(props.per1mUsd) : null;
</script>

<template>
  <article class="card p-5 flex flex-col gap-3">
    <header>
      <h3 class="font-display text-lg font-semibold text-ink">{{ name }}</h3>
      <p class="text-xs font-mono text-body mt-1 break-all">{{ id }}</p>
    </header>

    <div class="flex flex-wrap gap-1.5">
      <span class="pill">{{ fmtContext(contextWindow) }}</span>
      <span v-if="tools" class="pill">Tools</span>
      <span v-if="reasoning" class="pill">Reasoning</span>
    </div>

    <div class="mt-auto pt-2 flex items-baseline gap-1.5">
      <span class="font-display text-xl font-semibold text-ink">{{ price ?? '—' }}</span>
      <span class="text-sm text-body">/ 1M tokens</span>
    </div>
  </article>
</template>
